import { useState, useEffect } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Dashboard from './components/Dashboard';
import CreateOperator from './components/CreateOperator';
import ManageOperators from './components/ManageOperators';
import CreatePricePlan from './components/CreatePricePlan';
import ManagePricePlans from './components/ManagePricePlans';
import CreateSubscription from './components/CreateSubscription';
import ManageSubscriptions from './components/ManageSubscriptions';
import Users from './components/Users';
import AdminLogin from './components/AdminLogin';
import OperatorLogin from './components/OperatorLogin';
import Countries from './components/Countries';
import MasterData from './components/MasterData';
import EmailTemplates from './components/EmailTemplates';
import Settings from './components/Settings';
import TicketSettings from './components/TicketSettings';
import GeneralSettings from './components/GeneralSettings';
import RouteSettings from './components/RouteSettings';
import TripSettings from './components/TripSettings';
import Tickets from './components/Tickets';
import CreateTicket from './components/CreateTicket';
import TicketDetails from './components/TicketDetails';
import ManageMembers from './components/ManageMembers';
import OperatorInvoices from './components/OperatorInvoices';
import OperatorDashboard from './components/OperatorDashboard';
import FinancialReports from './components/FinancialReports';
import ManageDrivers from './components/ManageDrivers';
import Vendors from './components/Vendors';
import VendorFleet from './components/VendorFleet';
import VendorDocuments from './components/VendorDocuments';
import VendorContracts from './components/VendorContracts';
import VendorPricing from './components/VendorPricing';
import VendorSettings from './components/VendorSettings';
import VendorDashboard from './components/VendorDashboard';
import VendorLogin from './components/VendorLogin';
import VendorPortal from './components/VendorPortal';
import ClientLogin from './components/ClientLogin';
import ClientDashboard from './components/ClientDashboard';
import OperatorClientDocuments from './components/OperatorClientDocuments';
import OperatorQuotations from './components/OperatorQuotations';
import OperatorTripList from './components/OperatorTripList';


import AllVehicles from './components/AllVehicles';
import FleetDashboard from './components/FleetDashboard';
import MaintenanceOverview from './components/MaintenanceOverview';
import MaintenanceWorkshopVendor from './components/MaintenanceWorkshopVendor';
import MaintenanceJobs from './components/MaintenanceJobs';
import FuelManagement from './components/FuelManagement';
import TyreBatteryTracking from './components/TyreBatteryTracking';
import TripOperations from './components/TripOperations';
import Routes from './components/trip-operations/Routes';
import RouteStops from './components/trip-operations/RouteStops';
import Trips from './components/trip-operations/Trips';
import Passengers from './components/trip-operations/Passengers';
import PassengerAllocation from './components/trip-operations/PassengerAllocation';
import TripReports from './components/trip-operations/TripReports';
import ManageClients from './components/ManageClients';
import ClientDetails from './components/ClientDetails';
import ClientSettings from './components/ClientSettings';
import OperatorExpenses from './components/OperatorExpenses';
import SpareParts from './components/SpareParts';
import Compliance from './components/Compliance';
import MaintenanceReports from './components/MaintenanceReports';
import VehicleCostAnalysis from './components/VehicleCostAnalysis';
import AdhocTrips from './components/trip-operations/OnDemandTrip';
import ShuttleBooking from './components/ShuttleBooking';
import Availability from './components/Availability';
import PettyCash from './components/PettyCash';
import PettyCashSetup from './components/PettyCashSetup';



// Read initial page from URL hash so refresh stays on the same page
const getInitialPage = () => {
  const hash = window.location.hash.replace('#', '');
  if (hash.startsWith('ticket-details/')) return 'ticket-details';
  if (hash.startsWith('create-ticket/')) return 'create-ticket';
  if (hash.startsWith('manage-members/')) return 'manage-members';
  const valid = [
    'dashboard', 'create-operator', 'manage-operators', 'create-price-plan', 'price-plans',
    'create-subscription', 'manage-subscriptions', 'users', 'countries', 'master-data',
    'email-templates', 'manage-templates', 'manage-campaigns', 'settings', 'ticket-settings', 'general-settings', 'route-settings', 'trip-settings',
    'tickets', 'create-ticket', 'ticket-details', 'manage-members',
    'fleet-management', 'fleet-dashboard', 'all-vehicles', 'vehicle-cost-analysis', 'vendors', 'vendor-fleet', 'vendor-pricing', 'vendor-contracts', 'vendor-documents', 'vendor-settings', 'vendor-dashboard',
    'maintenance-overview', 'maintenance-workshop-vendor', 'maintenance-jobs', 'fuel-management', 'tyres-battery', 'compliance', 'spare-parts', 'maintenance-reports',
    'drivers', 'vendor-drivers', 'operator-login', 'superadmin-login', 'vendor-login', 'client-login',
    'operator-dashboard', 'operator-trip-list', 'operator-invoices', 'operator-quotations', 'operator-expenses', 'expense-categories', 'payment-methods', 'trip-status', 'vehicle-types', 'vehicle-status', 'fuel-types', 'service-types', 'compliance-types', 'document-types', 'driver-status', 'operator-finance-vendors', 'operator-financial-reports',
    'petty-cash', 'petty-cash-setup',
    'trip-operations', 'routes', 'route-stops', 'trips', 'passengers', 'passenger-allocation', 'trip-reports', 'adhoc-trips', 'shuttle-booking', 'availability', 'manage-clients', 'client-details', 'client-settings', 'client-documents'
  ];
  const page = hash.split('/')[0];
  if (valid.includes(page)) return page;

  // Fallback if no valid hash: Check user type from localStorage
  const savedUser = localStorage.getItem('ops-user');
  if (savedUser) {
    try {
      const u = JSON.parse(savedUser);
      if (u.userType === 'operator') return 'operator-dashboard';
      if (u.userType === 'admin') return 'dashboard';
    } catch (e) {
      console.error("Error parsing saved user:", e);
    }
  }
  return 'operator-login';
};


function App() {
  const [isDark, setIsDark] = useState(false);
  const [activePage, setActivePage] = useState(getInitialPage);
  const [editOperator, setEditOperator] = useState(null);
  const [editPricePlan, setEditPricePlan] = useState(null);
  const [editTicket, setEditTicket] = useState(null);
  const [user, setUser] = useState(null);
  const [operatorDetails, setOperatorDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('ops-user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);

    const handleHash = () => {
      setActivePage(getInitialPage());
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

  useEffect(() => {
    if (user && user.operatorId) {
      fetch(`/api/operators/${user.operatorId}`)
        .then(res => res.json())
        .then(data => {
          setOperatorDetails(data);
        })
        .catch(err => console.error("Error fetching operator details:", err));
    } else {
      setOperatorDetails(null);
    }
  }, [user]);

  useEffect(() => {
    const isClientOrVendor = user?.userType === 'client' || user?.userType === 'vendor';
    if (operatorDetails && operatorDetails.companyName && isClientOrVendor) {
      document.title = `${operatorDetails.companyName} | Portal`;
    } else {
      document.title = 'Opsmaticz – Intelligent Fleet Operations';
    }
  }, [operatorDetails, user]);

  const handleLogin = (userData) => {
    setUser(userData);
    if (userData.userType === 'vendor') {
      setActivePage('vendor-portal');
    } else if (userData.userType === 'client') {
      setActivePage('client-portal');
    } else if (userData.userType === 'operator') {
      goTo('operator-dashboard');
    } else {
      goTo('dashboard');
    }
  };

  const handleLogout = () => {
    const type = user?.userType;
    localStorage.removeItem('ops-user');
    setUser(null);
    if (type === 'admin') {
      goTo('superadmin-login');
    } else if (type === 'vendor') {
      goTo('vendor-login');
    } else if (type === 'client') {
      goTo('client-login');
    } else {
      goTo('operator-login');
    }
  };

  const goTo = (page, id = null) => {
    const hash = id ? `${page}/${id}` : page;
    window.location.hash = hash;
    setActivePage(page);
  };

  // ... (rest of the logic remains same until return)

  if (loading) return null;

  if (!user) {
    if (activePage === 'superadmin-login') {
      return <AdminLogin onLogin={handleLogin} />;
    }
    if (activePage === 'vendor-login') {
      return <VendorLogin onLogin={handleLogin} />;
    }
    if (activePage === 'client-login') {
      return <ClientLogin onLogin={handleLogin} />;
    }
    return <OperatorLogin onLogin={handleLogin} />;
  }

  // Vendor portal: full-screen, no operator shell
  if (user?.userType === 'vendor') {
    return <VendorPortal vendor={user} onLogout={handleLogout} operatorDetails={operatorDetails} />;
  }

  // Client portal: full-screen, no operator shell
  if (user?.userType === 'client') {
    return <ClientDashboard client={user} onLogout={handleLogout} operatorDetails={operatorDetails} />;
  }


  const renderPage = () => {
    // Inject user permissions into components if needed
    switch (activePage) {
      case 'create-price-plan':
        if (user?.userType !== 'admin' && !user?.permissions?.includes('Create Price Plan') && !user?.permissions?.includes('Edit Price Plan')) {
          return user?.userType === 'operator' ? (
            <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={goTo} />
          ) : (
            <Dashboard user={user} />
          );
        }
        return (
          <CreatePricePlan
            user={user}
            editPlan={editPricePlan}
            onSaved={() => {
              if (editPricePlan) {
                setEditPricePlan(null);
                goTo('price-plans');
              }
            }}
          />
        );
      case 'price-plans':
        return (
          <ManagePricePlans
            user={user}
            onEdit={(plan) => {
              setEditPricePlan(plan);
              goTo('create-price-plan');
            }}
            onCreate={() => goTo('create-price-plan')}
          />
        );
      case 'countries':
        return <Countries user={user} />;
      case 'master-data':
        return <MasterData user={user} />;
      case 'email-templates':
      case 'manage-templates':
        return <EmailTemplates user={user} />;
      case 'manage-campaigns':
        return (
          <div style={{ padding: 40, color: '#64748b', fontSize: 16.71 }}>
            <h2 style={{ marginBottom: 8, color: '#1e293b' }}>Manage Campaigns</h2>
            <p>Coming soon — campaign management will be available here.</p>
          </div>
        );
      case 'settings':
        return <Settings onNavigate={goTo} />;
      case 'ticket-settings':
        return <TicketSettings user={user} />;
      case 'general-settings':
        return <GeneralSettings />;
      case 'route-settings':
        return <RouteSettings />;
      case 'trip-settings':
        return <TripSettings />;
      case 'create-operator':
        if (user?.userType !== 'admin' && !user?.permissions?.includes('Create Operator') && !user?.permissions?.includes('Edit Operator')) {
          return user?.userType === 'operator' ? (
            <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={goTo} />
          ) : (
            <Dashboard user={user} />
          );
        }
        return (
          <CreateOperator
            user={user}
            editOperator={editOperator}
            onSaved={() => {
              if (editOperator) {
                setEditOperator(null);
                goTo('manage-operators');
              }
            }}
          />
        );
      case 'manage-operators':
        return <ManageOperators
          user={user}
          onEdit={(op) => {
            setEditOperator(op);
            goTo('create-operator');
          }}
          onManageMembers={(op) => goTo('manage-members', op._id)}
        />;
      case 'create-subscription':
        if (user?.userType !== 'admin' && !user?.permissions?.includes('Create Subscription')) {
          return user?.userType === 'operator' ? (
            <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={goTo} />
          ) : (
            <Dashboard user={user} />
          );
        }
        return <CreateSubscription />;
      case 'manage-subscriptions':
        return <ManageSubscriptions user={user} onCreate={() => goTo('create-subscription')} />;
      case 'users':
        return <Users user={user} />;
      case 'tickets':
        return <Tickets user={user}
          onEdit={(ticket) => {
            setEditTicket(ticket);
            goTo('create-ticket');
          }}
          onReply={(ticket) => {
            setEditTicket(ticket);
            goTo('ticket-details', ticket._id);
          }}
          onCreate={() => {
            setEditTicket(null);
            goTo('create-ticket');
          }} />;
      case 'create-ticket':
        return <CreateTicket
          key={editTicket?._id || 'new'}
          editTicket={editTicket}
          user={user}
          onSaved={() => {
            setEditTicket(null);
            goTo('tickets');
          }}
          onCancel={() => {
            setEditTicket(null);
            goTo('tickets');
          }}
        />;
      case 'ticket-details':
        return <TicketDetails
          ticket={editTicket}
          user={user}
          onBack={() => {
            setEditTicket(null);
            goTo('tickets');
          }}
          onSaved={() => {
            // refresh ticket data if needed or just go back
            goTo('tickets');
          }}
        />;
      case 'manage-members':
        const opId = window.location.hash.split('/')[1];
        return <ManageMembers
          operatorId={opId}
          onBack={() => goTo('manage-operators')}
        />;
      case 'fleet-dashboard':
      case 'fleet-management':
        return <FleetDashboard user={user} onNavigate={goTo} operatorDetails={operatorDetails} />;
      case 'all-vehicles':
        return <AllVehicles user={user} operatorDetails={operatorDetails} />;
      case 'vehicle-cost-analysis':
        return <VehicleCostAnalysis user={user} operatorDetails={operatorDetails} />;
      case 'maintenance-overview':
        return <MaintenanceOverview user={user} onNavigate={goTo} operatorDetails={operatorDetails} />;
      case 'maintenance-workshop-vendor':
        return <MaintenanceWorkshopVendor user={user} operatorDetails={operatorDetails} />;
      case 'maintenance-jobs':
        return <MaintenanceJobs user={user} operatorDetails={operatorDetails} />;
      case 'fuel-management':
        return <FuelManagement user={user} operatorDetails={operatorDetails} />;
      case 'tyres-battery':
        return <TyreBatteryTracking user={user} operatorDetails={operatorDetails} />;
      case 'compliance':
        return <Compliance user={user} operatorDetails={operatorDetails} />;
      case 'spare-parts':
        return <SpareParts user={user} operatorDetails={operatorDetails} />;
      case 'maintenance-reports':
        return <MaintenanceReports user={user} operatorDetails={operatorDetails} />;
      case 'drivers':
        return <ManageDrivers user={user} operatorDetails={operatorDetails} />;
      case 'vendor-drivers':
        return <ManageDrivers user={user} operatorDetails={operatorDetails} vendorOnly={true} />;





      case 'vendors':
        return <Vendors user={user} operatorDetails={operatorDetails} />;
      case 'vendor-dashboard':
        return <VendorDashboard user={user} operatorDetails={operatorDetails} />;
      case 'vendor-fleet':
        return <VendorFleet user={user} operatorDetails={operatorDetails} />;
      case 'vendor-documents':
        return <VendorDocuments user={user} operatorDetails={operatorDetails} />;
      case 'vendor-contracts':
        return <VendorContracts user={user} operatorDetails={operatorDetails} />;
      case 'vendor-pricing':
        return <VendorPricing user={user} operatorDetails={operatorDetails} />;
      case 'vendor-settings':
        return <VendorSettings user={user} operatorDetails={operatorDetails} />;

      case 'manage-clients':
        return <ManageClients user={user} onNavigate={goTo} operatorDetails={operatorDetails} />;

      case 'client-details':
        const clientId = window.location.hash.split('/')[1];
        return <ClientDetails clientId={clientId} onBack={() => goTo('manage-clients')} />;

      case 'client-settings':
        return <ClientSettings />;
      case 'client-documents':
        return <OperatorClientDocuments user={user} operatorDetails={operatorDetails} />;

      /* Operator pages */
      case 'operator-dashboard':
        return <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={(page, status) => {
          window.location.hash = status ? `${page}/${status}` : page;
          setActivePage(page);
        }} />;
      case 'operator-trip-list': {
        const tripStatus = window.location.hash.replace('#', '').split('/')[1] || 'Scheduled';
        return <OperatorTripList user={user} status={tripStatus} onBack={() => goTo('operator-dashboard')} />;
      }
      case 'operator-invoices':
        return <OperatorInvoices user={user} operatorDetails={operatorDetails} />;
      case 'operator-quotations':
        return <OperatorQuotations user={user} operatorDetails={operatorDetails} />;
      case 'expense-categories':
      case 'payment-methods':
      case 'trip-status':
      case 'vehicle-types':
      case 'vehicle-status':
      case 'fuel-types':
      case 'service-types':
      case 'compliance-types':
      case 'document-types':
      case 'driver-status':
        const tab = activePage === 'expense-categories' ? 'expense-categories' : activePage;
        return <MasterData user={user} initialTab={tab} operatorDetails={operatorDetails} />;
      case 'operator-expenses':
        return <OperatorExpenses user={user} operatorDetails={operatorDetails} />;
      case 'operator-finance-vendors':
        return <div className="operator-page"><h1 className="op-title">Finance Vendors</h1><p>Manage finance-related vendors.</p></div>;
      case 'operator-financial-reports':
        return <FinancialReports user={user} operatorDetails={operatorDetails} />;
      case 'petty-cash':
        return <PettyCash user={user} />;
      case 'petty-cash-setup':
        return <PettyCashSetup onBack={() => goTo('petty-cash')} />;
      case 'trip-operations':
        return <TripOperations user={user} />;
      case 'routes':
        return <Routes user={user} />;
      case 'route-stops':
        return <RouteStops user={user} />;
      case 'trips':
        return <Trips user={user} onNavigate={goTo} />;
      case 'passengers':
        return <Passengers user={user} />;
      case 'passenger-allocation':
        return <PassengerAllocation user={user} />;
      case 'trip-reports':
        return <TripReports user={user} />;
      case 'adhoc-trips':
        return <AdhocTrips user={user} operatorDetails={operatorDetails} />;
      case 'shuttle-booking':
        return <ShuttleBooking user={user} />;
      case 'availability':
        return <Availability user={user} />;

      case 'dashboard':
      default:
        if (user?.userType === 'operator') {
          return <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={(page, status) => {
            window.location.hash = status ? `${page}/${status}` : page;
            setActivePage(page);
          }} />;
        }
        return <Dashboard user={user} operatorDetails={operatorDetails} />;
    }
  };

  return (
    <div className={`app-shell ${isDark ? 'theme-dark' : 'theme-light'}`}>
      <Sidebar activePage={activePage} onNavigate={(page) => {
        if (page !== 'create-operator') setEditOperator(null);
        if (page !== 'create-price-plan') setEditPricePlan(null);
        goTo(page);
      }} user={user} onLogout={handleLogout} operatorDetails={operatorDetails} />
      <div className="main-content">
        <Topbar isDark={isDark} onToggleTheme={() => setIsDark(d => !d)} onLogout={handleLogout} user={user} operatorDetails={operatorDetails} />
        {renderPage()}
      </div>
    </div>
  );
}

export default App;